import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import { withRouter } from 'kts-platform-frame/routes';
import { Form, Button, Row, Col, Input, Select, DatePicker, Divider, Icon, Tooltip, InputNumber } from 'antd';
import { create } from 'kts-scaffold-framework/utils/form';
import moment from 'moment';
import ModulesFormAction from './Modules.Form.Action';

const Option = Select.Option;
const FormItem = Form.Item;
const css = require('./index.scss');

/** Redux接口 */
interface IReduxStatePart {

}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {
    formData: any;
    index: any;
    onChange?: (value: any) => void;
}

/** 绑定全局数据到props */
@create({
    onValuesChange: (props, changedValues, allValues) => {
        // ModulesAction.changeOrderTable(allValues, props.index - 1);
        // props.onChange();
    },
    // mapPropsToFields(props: any) {
    //     return {
    //         ID: Form.createFormField({ value: props.formData.ID }),
    //         Number: Form.createFormField({ value: props.formData.Number }),
    //         Name: Form.createFormField({ value: props.formData.Name }),
    //         Quantity: Form.createFormField({ value: props.formData.Quantity }),
    //         LineExtensionAmount: Form.createFormField({ value: props.formData.LineExtensionAmount }),
    //         ModelName: Form.createFormField({ value: props.formData.ModelName }),
    //         Description: Form.createFormField({ value: props.formData.Description }),
    //         UnitCode: Form.createFormField({ value: props.formData.UnitCode }),
    //         Price: Form.createFormField({ value: props.formData.Price }),
    //     };
    // },
})
@withRouter
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({

}))
export default class UIComponents extends UIBasic<IProps, ModulesState, {}> {
    // 拆分
    public TBD = [];
    // 是否禁用输入计划数量(当有拆分 禁用输入)
    public isReadOnly = false;
    // 计划名称 错误提示行
    public errorDate = [];
    // 拆分数量 错误提示行
    public errorQuantity = [];

    constructor(props: IProps) {
        super(props, ModulesAction);
    }
    componentWillReceiveProps() {
        // this.props.getFieldsError()
    }
    componentDidMount() {
        this.props.form.setFieldsValue({ ForecastStageQuantity: this.TBD });
    }
    render() {
        const { form, index, formData } = this.props; // 获取你的props数据

        const { getFieldDecorator } = form;
        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 24 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 24 },
            },
        };
        const messageInfos = this.modulesState.messageInfos;
        const key = this.modulesState.linesKey[index - 1];
        return (
            <Form className={css.commonFormTable} layout="vertical">
                <Divider />
                <Row gutter={20}>
                    <Col span={2}>
                        <div className={css.indexIcon} style={{ textAlign: 'center' }}>
                            <Tooltip title="删除该行数据">
                                <Icon
                                    onClick={() => { ModulesAction.deletCommonTable(index - 1); }}
                                    type="minus-circle"
                                    style={{ fontSize: 18, color: 'red' }}
                                />
                            </Tooltip>
                            <span className={css.number}>{index < 10 ? '0' + index : index}</span>
                        </div>
                    </Col>
                    <Col span={5}>
                        <FormItem
                            {...formItemLayout}
                            label="采购商品编号"
                        >
                            {getFieldDecorator('BuyersItemIdentification', {
                                initialValue: formData.BuyersItemIdentification,
                                rules: [{
                                    required: false,
                                    //规则注释 pattern: /^.{0,50}$/,
                                    //规则注释 message: '支持不超过50个字符',
                                    ...ModulesAction.getExtraRules('BuyersItemIdentification', true)
                                }],
                            })(
                                <Input
                                    placeholder=""
                                    onBlur={e => ModulesFormAction.validateFormValue({
                                        fieldName: 'BuyersItemIdentification',
                                        fieldType: 'LineField',
                                        line: key,
                                        value: e.target.value,
                                    })}
                                />
                            )}
                            {ModulesFormAction.setMessageInfos(messageInfos.get('BuyersItemIdentification_' + key))}
                        </FormItem>
                    </Col>
                    <Col span={5}>
                        <FormItem
                            {...formItemLayout}
                            label="采购商品名称"
                        >
                            {getFieldDecorator('BuyersItemName', {
                                initialValue: formData.BuyersItemName,
                                rules: [{
                                    required: false,
                                    //规则注释 pattern: /^.{0,100}$/,
                                    //规则注释 message: '支持不超过100个字符',
                                    ...ModulesAction.getExtraRules('BuyersItemName', true)
                                }],
                            })(
                                <Input
                                    placeholder=""
                                    onBlur={e => ModulesFormAction.validateFormValue({
                                        fieldName: 'BuyersItemName',
                                        fieldType: 'LineField',
                                        line: key,
                                        value: e.target.value,
                                    })}
                                />
                            )}
                            {ModulesFormAction.setMessageInfos(messageInfos.get('BuyersItemName_' + key))}
                        </FormItem>
                    </Col>
                    <Col span={5}>
                        <FormItem
                            {...formItemLayout}
                            label="采购规格/型号"
                        >
                            {getFieldDecorator('BuyersItemModelName', {
                                initialValue: formData.BuyersItemModelName,
                                rules: [{
                                    required: false,
                                    //规则注释 pattern: /^.{0,100}$/,
                                    //规则注释 message: '支持不超过100个字符',
                                    ...ModulesAction.getExtraRules('BuyersItemModelName', true)
                                }]
                            })(
                                <Input
                                    placeholder=""
                                    onBlur={e => ModulesFormAction.validateFormValue({
                                        fieldName: 'BuyersItemModelName',
                                        fieldType: 'LineField',
                                        line: key,
                                        value: e.target.value,
                                    })}
                                />
                            )}
                            {ModulesFormAction.setMessageInfos(messageInfos.get('BuyersItemModelName_' + key))}
                        </FormItem>
                    </Col>
                    <Col span={2}>
                        <FormItem
                            {...formItemLayout}
                            label="单位"
                        >
                            {getFieldDecorator('UnitCode', {
                                initialValue: formData.UnitCode,
                                rules: [{
                                    required: false,
                                    message: '请选择单位',
                                    ...ModulesAction.getExtraRules('UnitCode', true)
                                }],
                            })(
                                <Select
                                    placeholder="请选择单位"
                                    onChange={e => ModulesFormAction.validateFormValue({
                                        fieldName: 'UnitCode',
                                        fieldType: 'LineField',
                                        line: key,
                                        value: e,
                                    })}
                                >
                                    <Option value="TNE">吨</Option>
                                    <Option value="KGM">千克</Option>
                                    <Option value="MTR">米</Option>
                                    <Option value="ST">片</Option>
                                    <Option value="ZZ1">支</Option>
                                    <Option value="EA">个</Option>
                                    <Option value="SET">套</Option>
                                    <Option value="BX">盒</Option>
                                    <Option value="ZZ0">台</Option>
                                    <Option value="CS">箱</Option>
                                    <Option value="PK">包</Option>
                                    <Option value="BO">瓶</Option>
                                    <Option value="H87">件</Option>
                                </Select>
                            )}
                            {ModulesFormAction.setMessageInfos(messageInfos.get('UnitCode_' + key))}
                        </FormItem>
                    </Col>
                    <Col span={4}>
                        <FormItem
                            {...formItemLayout}
                            label="计划数量"
                        >
                            {getFieldDecorator('Quantity', {
                                initialValue: formData.Quantity,
                                rules: [{
                                    required: true,
                                    validator: ModulesFormAction.validateField,
                                    message: '必填',
                                    //规则注释 validator: this.checkQuantity,
                                    ...ModulesAction.getExtraRules('Quantity', true)
                                    // pattern: /^[0-9](?:\d{0,14}\.\d{0,2}|\d{0,14})$/,
                                    //规则注释 message: '支持不超过15位数字',
                                }],
                            })(
                                <InputNumber
                                    // type="number"
                                    placeholder=""
                                    readOnly={this.isReadOnly}
                                    disabled={this.isReadOnly}
                                    onBlur={e => ModulesFormAction.validateFormValue({
                                        fieldName: 'Quantity',
                                        fieldType: 'LineField',
                                        line: key,
                                        value: e.target.value,
                                    })}
                                />
                            )}
                            {ModulesFormAction.setMessageInfos(messageInfos.get('Quantity_' + key))}
                        </FormItem>
                    </Col>
                    <Col span={1}>
                        <FormItem
                            label=""
                        >
                            {getFieldDecorator('ForecastStageQuantity', {
                                initialValue: undefined,
                                rules: [{
                                    required: true,
                                    validator: this.ForecastStageQuantity,
                                    // pattern: /^[0-9](?:\d{0,14}\.\d{0,2}|\d{0,14})$/,
                                    // message: '支持不超过15位数字',
                                    message: '必填',
                                }],
                            })(
                                <div className={css.splitQuantity}>
                                    <a onClick={() => this.splitQuantity(index)}>拆分</a>
                                </div>
                            )}
                            {ModulesFormAction.setMessageInfos(messageInfos.get('ForecastStageQuantity_' + key))}
                        </FormItem>
                    </Col>
                </Row>
                <Row>
                    <Col span={14} offset={2} >
                        <Row gutter={20}>
                            <Col span={10}>
                                <FormItem
                                    {...formItemLayout}
                                    label="销售商品编号"
                                >
                                    {getFieldDecorator('SellersItemIdentification', {
                                        initialValue: formData.SellersItemIdentification,
                                        rules: [{
                                            required: false,
                                            //规则注释 pattern: /^.{0,50}$/,
                                            //规则注释 message: '支持不超过50个字符',
                                            ...ModulesAction.getExtraRules('SellersItemIdentification', true)
                                        }],
                                    })(
                                        <Input
                                            placeholder=""
                                            onBlur={e => ModulesFormAction.validateFormValue({
                                                fieldName: 'SellersItemIdentification',
                                                fieldType: 'LineField',
                                                line: key,
                                                value: e.target.value,
                                            })}
                                        />
                                    )}
                                    {ModulesFormAction.setMessageInfos(messageInfos.get('SellersItemIdentification_' + key))}
                                </FormItem>
                            </Col>
                            <Col span={10}>
                                <FormItem
                                    {...formItemLayout}
                                    label="销售商品名称"
                                >
                                    {getFieldDecorator('SellersItemName', {
                                        initialValue: formData.SellersItemName,
                                        rules: [{
                                            required: false,
                                            //规则注释 pattern: /^.{0,100}$/,
                                            //规则注释 message: '支持不超过100个字符',
                                            ...ModulesAction.getExtraRules('SellersItemName', true)
                                        }],
                                    })(
                                        <Input
                                            placeholder=""
                                            onBlur={e => ModulesFormAction.validateFormValue({
                                                fieldName: 'SellersItemName',
                                                fieldType: 'LineField',
                                                line: key,
                                                value: e.target.value,
                                            })}
                                        />
                                    )}
                                    {ModulesFormAction.setMessageInfos(messageInfos.get('SellersItemName_' + key))}
                                </FormItem>
                            </Col>
                            <Col span={10}>
                                <FormItem
                                    {...formItemLayout}
                                    label="销售规格/型号"
                                >
                                    {getFieldDecorator('SellersItemModelName', {
                                        initialValue: formData.SellersItemModelName,
                                        rules: [{
                                            required: false,
                                            //规则注释 pattern: /^.{0,100}$/,
                                            //规则注释 message: '支持不超过100个字符',
                                            ...ModulesAction.getExtraRules('SellersItemModelName', true)
                                        }],
                                    })(
                                        <Input
                                            placeholder=""
                                            onBlur={e => ModulesFormAction.validateFormValue({
                                                fieldName: 'SellersItemModelName',
                                                fieldType: 'LineField',
                                                line: key,
                                                value: e.target.value,
                                            })}
                                        />
                                    )}
                                    {ModulesFormAction.setMessageInfos(messageInfos.get('SellersItemModelName_' + key))}
                                </FormItem>
                            </Col>
                            <Col span={10}>
                                <FormItem
                                    {...formItemLayout}
                                    label="来源单据"
                                >
                                    {getFieldDecorator('DocumentReference', {
                                        initialValue: formData.DocumentReference,
                                        rules: [{
                                            required: false,
                                            //规则注释 pattern: /^.{0,50}$/,
                                            //规则注释 message: '支持不超过50个字符',
                                            ...ModulesAction.getExtraRules('DocumentReference', true)
                                        }],
                                    })(
                                        <Input
                                            placeholder=""
                                            onBlur={e => ModulesFormAction.validateFormValue({
                                                fieldName: 'DocumentReference',
                                                fieldType: 'LineField',
                                                line: key,
                                                value: e.target.value,
                                            })}
                                        />
                                    )}
                                    {ModulesFormAction.setMessageInfos(messageInfos.get('DocumentReference_' + key))}
                                </FormItem>
                            </Col>
                            <Col span={10}>
                                <FormItem
                                    {...formItemLayout}
                                    label="来源单据行"
                                >
                                    {getFieldDecorator('LineReference', {
                                        initialValue: formData.LineReference,
                                        rules: [{
                                            required: false,
                                            //规则注释 pattern: /^.{0,50}$/,
                                            //规则注释 message: '支持不超过50个字符',
                                            ...ModulesAction.getExtraRules('LineReference', true)
                                        }],
                                    })(
                                        <Input
                                            placeholder=""
                                            onBlur={e => ModulesFormAction.validateFormValue({
                                                fieldName: 'LineReference',
                                                fieldType: 'LineField',
                                                line: key,
                                                value: e.target.value,
                                            })}
                                        />
                                    )}
                                    {ModulesFormAction.setMessageInfos(messageInfos.get('LineReference_' + key))}
                                </FormItem>
                            </Col>
                            <Col span={10}>
                                <FormItem
                                    {...formItemLayout}
                                    label="其他描述"
                                >
                                    {getFieldDecorator('Description', {
                                        initialValue: formData.Description,
                                        rules: [{
                                            required: false,
                                            //规则注释 pattern: /^.{0,100}$/,
                                            //规则注释 message: '支持不超过100个字符',
                                            ...ModulesAction.getExtraRules('Description', true)
                                        }],
                                    })(
                                        <Input
                                            placeholder=""
                                            onBlur={e => ModulesFormAction.validateFormValue({
                                                fieldName: 'Description',
                                                fieldType: 'LineField',
                                                line: key,
                                                value: e.target.value,
                                            })}
                                        />
                                    )}
                                    {ModulesFormAction.setMessageInfos(messageInfos.get('Description_' + key))}
                                </FormItem>
                            </Col>
                            {ModulesAction.getExtraTemplate(this.modulesState.forecastForm, form, formItemLayout, true, 10, index - 1)}
                        </Row>
                    </Col>
                    <Col span={8}>
                        {this.getSplitDetail(index)}
                    </Col>
                </Row>
            </Form>
        );
    }
    /**
     * 检测是否 通过拆分规则
     */
    private ForecastStageQuantity = (rule: any, value: any, callback: any) => {
        if (this.errorDate.length > 0 || this.errorQuantity.length > 0) {
            return callback('');
        } else {
            return callback();
        }
    }
    /**
     * 拆分 按钮
     */
    private splitQuantity = (index) => {
        if (this.TBD.length === 0) {
            this.props.form.setFieldsValue({ Quantity: undefined });
        }
        this.isReadOnly = true;
        ModulesAction.splitQuantity(index - 1);
    }
    /**
     * 获取拆分列 展示html
     */
    private getSplitDetail = (rowindex) => {
        const { getFieldDecorator } = this.props.form;
        let list = [];
        this.TBD = this.props.formData.ForecastStageQuantity;
        this.isReadOnly = this.TBD.length > 0 ? true : false;
        this.props.formData.ForecastStageQuantity.forEach((item, index) => {

            let isErrorQuantity = this.errorQuantity.indexOf(index) > -1;
            let isErrorDate = this.errorDate.indexOf(index) > -1;
            list.push(
                <Row gutter={20} className={css.splitDetail} key={index} style={{ paddingTop: '30px' }}>
                    <Col span={11}>
                        {
                            <div className={isErrorDate ? 'has-error' : ''}>
                                <DatePicker
                                    placeholder="日期"
                                    defaultValue={item ? ModulesAction.timeStampToFormat(item.Qualifier) : undefined}
                                    showTime={{ format: this.modulesState.timeFormat }}
                                    onChange={(e) => { this.changeDate(e, index); }}
                                    style={{ width: '100%' }}
                                    format={this.modulesState.dateFormat}
                                />
                                {/* 修改前的文本模式 */}
                                {/* <Input placeholder="日期" value={item?item.Qualifier:undefined} onChange={(e) => { this.changeDate(e, index); }} /> */}
                                {isErrorDate && <div className="ant-form-explain">支持不超过20个字符</div>}
                            </div>
                        }
                    </Col>
                    <Col span={10}>
                        {
                            <div className={isErrorQuantity ? 'has-error' : ''}>
                                <InputNumber
                                    placeholder="拆分数量"
                                    // type="number"
                                    value={item ? item.Quantity : undefined}
                                    onChange={(e) => { this.changeQuantity(e, index); }}
                                />
                                {isErrorQuantity && <div className="ant-form-explain">支持不超过15位正数</div>}
                            </div>
                        }
                    </Col>
                    <Col span={3}>
                        <div className={css.deletQuantity}>
                            <a onClick={() => this.deletesplitQuantity(rowindex - 1, index)}>删除</a>
                        </div>
                    </Col>
                </Row>
            );
        });
        return list;
    }

    /**
     * 删除 
     */
    private deletesplitQuantity = (rowindex, index) => {
        if (this.TBD.length === 1) {
            this.isReadOnly = false;
        }
        ModulesAction.deletesplitQuantity(rowindex, index);
        this.props.form.setFieldsValue({ ForecastStageQuantity: this.TBD });
        this.isEqTotal();
    }
    /**
     * 同步数据到TBD(数量)
     */
    private changeQuantity = (e, index) => {
        this.TBD[index].Quantity = e;
        // this.TBD[index].Quantity = e.target.value;
        this.props.form.setFieldsValue({ ForecastStageQuantity: this.TBD });

        this.isEqTotal();
        // 错误提示
        let findindex = this.errorQuantity.findIndex((val, i, arrs) => {
            return val === index;
        });

        // if (!this.checkStageQuantity(e.target.value)) {
        if (!this.checkStageQuantity(e)) {
            if (findindex < 0) {
                this.errorQuantity.push(index);
            }
        } else if (findindex >= 0) {
            this.errorQuantity.splice(findindex, 1);
        }
    }
    /**
     * 检验拆分行 检验
     */
    private checkStageQuantity = (value: any) => {
        let arr = value ? value.toString().split(".") : [''];
        if (isNaN(value) || value < 0) {
            return false;
        } else if (arr.length > 1 && arr[0].length + arr[1].length > 15) {
            return false;
        } else if (arr.length <= 1 && arr[0].length > 15) {
            return false;
        } else {
            return true;
        }
    }
    /**
     * 同步数据到TBD(计划名称)
     */
    private changeDate = (e, index) => {
        // 文本模式(修改前)
        // this.TBD[index].Qualifier = e.target.value;

        // 时间模式(修改后)
        this.TBD[index].Qualifier = e ? !e._isUTC ? e._d.valueOf() : (e._d.valueOf() - 28800000) : e;

        this.props.form.setFieldsValue({ ForecastStageQuantity: this.TBD });
        // 检验 文本模式(修改前)
        // let findindex = this.errorDate.findIndex((val, i, arrs) => {
        //     return val === index;
        // });
        // let value = e.target.value;
        // let arr = e.target.value ? e.target.value.toString().split(".") : [''];
        // if (findindex < 0 && value.length > 20) {
        //     this.errorDate.push(index);
        // } else if (findindex > -1 && value.length <= 20) {
        //     this.errorDate.splice(findindex,1);
        // }

    }
    /**
     * 小数精确加法
     */
    private accAdd = (arg1, arg2) => {
        let r1, r2, m;
        try {
            r1 = arg1.toString().split(".")[1].length;
        } catch (e) {
            r1 = 0;
        } try {
            r2 = arg2.toString().split(".")[1].length;
        } catch (e) {
            r2 = 0;
        }
        m = Math.pow(10, Math.max(r1, r2));
        return (arg1 * m + arg2 * m) / m;
    }

    /**
     * 计算当前 拆分总数和 是否等于 计划数
     */
    private isEqTotal = () => {
        if (this.TBD.length === 0) {
            return true;
        }
        let total = 0;
        let Quantity = Number(this.props.form.getFieldValue('Quantity'));
        this.TBD.forEach((item: any) => {
            if (item && item.Quantity && this.checkStageQuantity(item.Quantity)) {
                total = this.accAdd(Number(item.Quantity), total);
            }
        });
        // this.props.form.setFieldsValue({ Quantity: total});
        if (total) {
            this.props.form.setFieldsValue({ Quantity: total });
        } else {
            this.props.form.setFields({
                Quantity: {
                    value: total,
                    errors: [new Error('支持不超过15位正数')],
                },
            });
        }

    }
    /**
     * 校验数量    规则注释 
     */
    // private checkQuantity = (rule: any, value: any, callback: any) => {
    //     let arr = value ? value.toString().split(".") : [''];
    //     this.isEqTotal();
    //     if (value === "0" || isNaN(value) || value < 0 || value === null || value === undefined || value === '') {
    //         return callback('支持不超过15位正数');
    //     } else if (arr.length > 1 && arr[0].length + arr[1].length > 15) {
    //         return callback('支持不超过15位正数');
    //     } else if (arr.length <= 1 && arr[0].length > 15) {
    //         return callback('支持不超过15位正数');
    //     } else {
    //         return callback();
    //     }
    // }
}


// WEBPACK FOOTER //
// ./src/display/platform/Document/EditDocument/UI.ForecastFormTable.tsx